let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <deliveryOrder>
        <deliveryOrderCode>ERP出库单号(ERP分配), string (50), 必填</deliveryOrderCode>
        <wmsOrderCode>WMS出库单号(WMS分配), string (50), 必填</wmsOrderCode>
        <createTime>出库单创建时间, string (19), YYYY-MM-DD HH:MM:SS,为空时WMS自动生成</createTime>
        <placedAt>下单时间, string (19), YYYY-MM-DD HH:MM:SS,为空时WMS自动生成</placedAt>
        <payTime>付款时间, string (19), YYYY-MM-DD HH:MM:SS</payTime>
        <datePlanned>预计到达时间, string (19), YYYY-MM-DD HH:MM:SS</datePlanned>
        <sourcePlatformCode>订单来源平台编码, string (50), TB= 淘宝、TM=天猫、JD=京东、DD=当当、PP=拍拍、YX=易讯、EBAY=ebay、QQ=QQ网购、AMAZON=亚马逊、SN=苏宁、GM=国美、WPH=唯品会、JM=聚美、LF=乐蜂、MGJ=蘑菇街、JS=聚尚、PX=拍鞋、YT=银泰、YHD=1号店、VANCL=凡客、YL=邮乐、YG=优购、1688=阿里巴巴、POS=POS门店、MIA=蜜芽、GW=商家官网、CT=村淘、OTHER=其他(只传英文编码), 条件必填, 条件是B2C订单</sourcePlatformCode>
        <logisticsCode>物流公司编码, string (50), 必填</logisticsCode>
        <shopNick>店铺名称 string(50), 条件必填, 条件为B2C订单</shopNick>
        <orderVolume>预期总体积, float</orderVolume>
        <orderGrossWeight>预期总毛重, float</orderGrossWeight>
        <productTotal>预期总数量, float</productTotal>
        <shippedVolumn>发运总体积, float</shippedVolumn>
        <shippedWeight>发运总毛重, float</shippedWeight>
        <shippedQty>发运总数量, float</shippedQty>
        <senderInfo>
            <company>公司名称, string (200)</company>
            <name>姓名, string (50)</name>
            <zipCode>邮编, string (50)</zipCode>
            <mobile>移动电话, string (50)</mobile>
            <countryCode>国家二字码, string (50)</countryCode>
            <province>省份, string (50)</province>
            <city>城市, string (50)</city>
            <area>区域, string (50)</area>
            <town>村镇, string (50)</town>
            <detailAddress>详细地址, string (200)</detailAddress>
        </senderInfo>
        <receiverInfo>
            <company>公司名称, string (200)</company>
            <name>姓名, string (50)</name>
            <zipCode>邮编, string (50)</zipCode>
            <tel>固定电话, string (50)</tel>
            <mobile>移动电话, string (50)</mobile>
            <countryCode>国家二字码, string (50)</countryCode>
            <province>省份, string (50)</province>
            <city>城市, string (50)</city>
            <area>区域, string (50)</area>
            <town>村镇, string (50)</town>
            <detailAddress>详细地址, string (200)</detailAddress>
        </receiverInfo>
        <remark>备注, string (500)</remark>
        <userDefined1>自定义1, string(50)</userDefined1>
        <userDefined2>自定义2, string(50)</userDefined2>
        <userDefined3>自定义3, string(50)</userDefined3>
        <userDefined4>自定义4, string(50)</userDefined4>
    </deliveryOrder>
    <orderLines>
        <orderLine>
            <itemCode>商品编码, string (50), 必填</itemCode>
            <itemId>仓储系统商品编码, string (50)</itemId>
            <planQty>应发商品数量, float, 必填</planQty>
            <shippedQty>实发商品数量, float</shippedQty>
            <actualPrice>价格 string (50)</actualPrice>
            <stockUnit>单位, string (50)，例如：个、瓶、支</stockUnit>
            <customJson>自定义json</customJson>
            <customField1>自定义字段1, string (50)</customField1>
            <customField2>自定义字段2, string (50)</customField2>
            <customField3>自定义字段3, string (50)</customField3>
            <customField4>自定义字段4, string (50)</customField4>
            <customField5>自定义字段5, string (50)</customField5>
            <customField6>自定义字段6, string (50)</customField6>
            <customField7>自定义字段7, string (50)</customField7>
            <customField8>自定义字段8, string (50)</customField8>
        </orderLine>
    </orderLines>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
    <waybillCode>快递面单号, string (50)</waybillCode>
    <printData>打印数据(pdfbase64, 图片base64, html)</printData>
    <printDataType>打印数据格式, pdf, image, html</printDataType>
    <shortAddress>大头笔, string (50)</shortAddress>
    <packageCenterCode>集包地名字, string (50)</packageCenterCode>
    <packageCenterName>集包地编码, string (50)</packageCenterName>
    <originName>原寄地名称, string (50)</originName>
    <originCode>原寄地编码, string (50)</originCode>
    <destName>目的地名称, string (50)</destName>
    <destCode>目的地编码, string (50)</destCode>
    <userDefined1>用户自定义1, string (50)</userDefined1>
    <userDefined2>用户自定义2, string (50)</userDefined2>
    <userDefined3>用户自定义3, string (50)</userDefined3>
    <userDefined4>用户自定义4, string (50)</userDefined4>
</response>
`

let NotificaitonURL = 'NotificaitonURL'

export default { xmlRequest, xmlResponse, NotificaitonURL }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.waybill.get.js